import { RemoveRedEye } from '@mui/icons-material';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  InputProps,
  Typography
} from '@mui/material';
import React, { useState } from 'react';



export type StyledInputTextFieldProps = {
  validationErrorMessage?: string;
  label?: string;
  helperText?: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
};

export const FC = (props: StyledInputTextFieldProps & Partial<InputProps>) => {
  const [
    showPassword,
    setShowPassword
  ] = useState(false);


  const isError = props.helperText && props.helperText.length > 1
    ? true
    : false;
  return (
    <FormControl
      fullWidth
      required={props.required}
      error={isError}
    >
      <FormLabel>
        <Typography
          variant='formLabel'
          sx={{
            margin: '0rem'
          }}
        >{props.label}
        </Typography>
      </FormLabel>

      <Input
        fullWidth
        disableUnderline
        multiline={props.minRows ? true : false}
        minRows={props.minRows ? props.minRows : 1}
        required={props.required}
        value={props.value}
        name={props.name}
        type={showPassword ? 'text' : props.type}
        endAdornment={
          props.type === 'password'
            ? <RemoveRedEye onClick={() => setShowPassword((prev) => !prev)} />
            : undefined
        }
        onChange={
          (e) => {
            props.onChange(e);
          }
        }
        sx={{
          '&.MuiInputBase-formControl': {
            marginTop: '.25rem'
          }
        }}
      />{
        props.helperText && props?.helperText.length > 1 && props.helperText !== 'Required.'
          ? (
            <FormHelperText variant='standard'>
              {props.helperText}
            </FormHelperText>
          )
          : (
            <>
            </>
          )
      }
    </FormControl>
  );
};
